/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';

import WidgetDialog from '../components/dialogs';
import ContentContainer from '../components/contentContainer';
import CopyLinkButton from '../components/copyLinkButton';
import TitleHeader from '../components/titleHeader';
import GuideLink from '../components/guidelink';
import PrimaryButton from '../components/primaryButton';

import { useStyles } from './styles';
import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import getCommonUIStyles from '../../commons/uiStyles';
import useICSLink from '../icslink/useICSLink';
import { useAppStore } from '../../store/models/app/';
import CommonImages from '../../commons/images/index';
import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';

import useKickstarted from '../../commons/hooks/useKickstarted';

function ICSLinkOutlook (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const  {
        translate,
        translateWithTags,
    } = useTranslator();

    const {
        widget,
        widgetTheme,
        hasCustomCSS,
    }  = useWidgetTheme();

    const [nextEnable, setNextEnable] = useState(false);
    const appStore = useAppStore();
    const {
        calendarURL,
        copyCalendarURL,
        inProgress,
        selectedCalendar,
    } = useICSLink();

    const classes = useStyles({
        inProgress,
        widget,
        widgetTheme,
        hasCustomCSS,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });

    usePageTransitions({
        elementName: TransitionViewNames.ICSLINK_OUTLOOK_VIEW,
        viewAnimation,
    });

     useKickstarted({});
    
    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    function nextText () {
        return (
            <b style={{ padding: '0 4px' }}>
                {translate(TranslationIds.CALENDAR_GUIDE_NEXT)}
            </b>
        );
    }

    function addCalendarText () {
        return (
            <b style={{ padding: '0 4px' }}>
                {translate(TranslationIds.CALENDAR_GUIDE_ADD_CALENDAR)}
            </b>
        );
    }

    function subscribeFromWebText () {
        return (
            <b style={{ padding: '0 4px' }}>
                {translate(TranslationIds.CALENDAR_GUIDE_SUBSCRIBE_FROM_WEB)}
            </b>
        );
    }

    function importText () {
        return (
            <b style={{ padding: '0 4px' }}>
                {translate(TranslationIds.CALENDAR_GUIDE_IMPORT)}
            </b>
        );
    }

    function getOutlookInlineIcon () {
        return (<img src={CommonImages.OUTLOOK_GUIDE_OUTOOK_LOGO} className={classes.inlineIcon} alt="Outlook" />);
    }

    function getCalendarIcon () {
         return (<img src={CommonImages.OUTLOOK_GUIDE_CALENDAR} className={classes.inlineIcon} alt="Calendar" />);
    }

    return (
        <React.Fragment>
            <ContentContainer
                viewAnimation={viewAnimation}
            >
                <WidgetDialog
                    isShowBackButton={false}
                    name={TransitionViewNames.ICSLINK_OUTLOOK_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                    >
                    <TitleHeader
                        widget={widget}
                        widgetTheme={widgetTheme}
                        title={`${translate(TranslationIds.CALENDAR_PROC_TITLE)}`}
                        subtitle={''}
                    />
                    <Grid className={classNames([classes.body])}>
                        <Grid className={classNames([classes.instructionSubTitle])}>
                            { translate(TranslationIds.CALENDAR_GUIDE_FOLLOW_THESE_STEPS) }
                        </Grid>

                        <Grid className={classes.guideContentBody}>
                            <Grid className={classes.guideContent}>

                                <Grid className={classNames([classes.stepRow, classes.stepRowSmallMargin])}>
                                    <span className={classes.stepNumber}>1.</span>
                                    <span className={classes.stepText}>
                                        { translate(TranslationIds.CALENDAR_GUIDE_COPY_THE_LINK) }
                                    </span>
                                </Grid> 
        
                                <Grid className={classNames([classes.linkSpace])}>
                                    <span className={classNames(['data-ecal-webcall-link', classes.link])}>
                                        { calendarURL }
                                    </span>

                                    <CopyLinkButton
                                        inProgress={nextEnable}
                                        buttonClass={nextEnable ?
                                            classNames([
                                                classes.copyButtonBase,
                                                classes.copyButtonSolid]) :
                                            classNames([
                                                classes.copyButtonBase,
                                                classes.copyButtonOutlined])
                                        }
                                        // progressClass={classes.progress}
                                    
                                        onClick={() => {
                                            setNextEnable(true);
                                            copyCalendarURL();
                                        }}
                                        copyLabel={translate(TranslationIds.CALENDAR_GUIDE_COPY)}
                                        // TODO: add copiedLabel translation language
                                        copiedLabel={translate(TranslationIds.CALENDAR_GUIDE_COPIED)}
                                    />
                                </Grid>

                                <Grid className={classes.stepsList}>
                                    {/* STEP 2 */}
                                    <Grid className={classes.stepRow}>
                                        <span
                                            className={classNames([classes.stepNumber, classes.stepNumberCenter])}
                                        >
                                            2.
                                        </span>
                                        <span className={classes.stepText}>
                                            { translateWithTags(
                                                TranslationIds.CALENDAR_GUIDE_OPEN_OUTLOOK_ON_DESKTOP,
                                                {
                                                    icon: getOutlookInlineIcon(),
                                                    nextlabel: nextText(),
                                                },
                                            )}
                                        </span>
                                    </Grid>

                                    {/* STEP 3 */}
                                    <Grid className={classes.stepRow}>
                                        <span
                                            className={classNames([classes.stepNumber, classes.stepNumberCenter])}
                                        >
                                                3.
                                            </span>
                                        <span className={classes.stepText}>
                                            { translateWithTags(
                                                TranslationIds.CALENDAR_GUIDE_SELECT_CALENDAR_OPTION,
                                                {
                                                    icon: getCalendarIcon(),
                                                },
                                            )}
                                        </span>
                                    </Grid>

                                    {/* STEP 4 */}
                                    <Grid className={classes.stepRow}>
                                        <span className={classes.stepNumber}>4.</span>
                                        <span className={classes.stepText}>
                                            { translateWithTags(
                                                TranslationIds.CALENDAR_GUIDE_ADD_CALENDAR_POPUP,
                                                {
                                                   subscribefromweblabel: subscribeFromWebText(),
                                                   addcallabel: addCalendarText(),
                                                },
                                            )}
                                        </span>
                                    </Grid>

                                    {/* STEP 5 */}
                                    <Grid
                                        className={classNames([classes.stepRow, classes.stepRowStep5Margin])}
                                    >
                                        <span className={classes.stepNumber}>5.</span>
                                        <span className={classes.stepText}>
                                            {translateWithTags(
                                                TranslationIds.CALENDAR_GUIDE_PASTE_THE_LINK,
                                                {
                                                   importlabel: importText(),
                                                },
                                            )}
                                        </span>
                                    </Grid>
                                </Grid>

                                <Grid className={classes.banner}>
                                    <object
                                        className={classes.bannerImage}
                                        data={CommonImages.OUTLOOK_GUIDE_INFO}
                                        type="image/svg+xml">
                                    </object>
                                </Grid>
                                
                            </Grid>
                        </Grid>
                     
                        <Grid className={classNames(["data-ecal-next-button-container", classes.nextButton])}>
                            <PrimaryButton
                                isDisabled={!nextEnable}
                                onClick={() => {
                                    appStore.gotoOutlookNewGuide();
                                    setNextEnable(false);
                                }}
                                textLabel={translate(TranslationIds.COMPONENT_NEXT)}
                            />
                        </Grid>

                        <Grid className={classes.help}>
                            { translate(TranslationIds.CALENDAR_PROC_NEED_HELP) }
                            <GuideLink
                                selectedCalendar={selectedCalendar}
                                label={translate(TranslationIds.CALENDAR_PROC_GUIDE)}
                                commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                            />
                        </Grid>
                    </Grid>
                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

ICSLinkOutlook.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(ICSLinkOutlook);
